import React from 'react';
import { compose } from 'redux';

// components
import Header from './_Header';
import { Link } from 'react-router';

// higher-order components
import requireUser from '../shared/requireUser';

const Manager = function(props) {
  return (
    <div className='manager__layout'>
      <Header>
        <Link activeClassName='header__left__nav__link--active'
          className='header__left__nav__link'
          to='/managers/calendar'>
          Manage Calendar
        </Link>
        <Link activeClassName='header__left__nav__link--active'
          className='header__left__nav__link'
          to='/managers/reps'>
          View Reps
        </Link>
        <Link activeClassName='header__left__nav__link--active'
          className='header__left__nav__link'
          to='/managers/doctors'>
          Manage Doctors
        </Link>
        <Link activeClassName='header__left__nav__link--active'
          className='header__left__nav__link header__left__nav__link--indicated'
          to='/managers/recommend-office'>
              Recommend Office
        </Link>
      </Header>
      <div className='manager__body'>
        <div className='manager__body__left' />
        <div className='manager__content'>
          { props.children }
        </div>
      </div>
    </div>
  );
};

export default compose(
  requireUser()
)(Manager);



// WEBPACK FOOTER //
// ./app/components/layouts/Manager.jsx